import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(r3, r4) {
  var result = Complex.createComplex((-1 * r4) / (r3 + r4), 0);
  return result;
}

export function computeComplexFF(complexRParallel, r3, r4) {
  var complexR1 = Complex.createComplex(r3 + r4, 0);
  var result = complexRParallel.divide(complexR1);
  return result;
}
